




































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Breadcrumb } from '@/interfaces/breadcrumbs'

@Component
export default class AppBreadcrumbs extends Vue {
  @Prop({ type: Array, default: [] }) readonly breadcrumbs!: Breadcrumb[];
  @Prop(Boolean) readonly showBack!: boolean;

  routeBack () {
    this.$router.go(-1)
  }
}
